var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    fill: "#1C274C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    cx: 11.9,
    cy: 20.1,
    r: 5.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 3.9,
    y1: 23.4,
    x2: 6.6,
    y2: 22.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 17.2,
    y1: 17.9,
    x2: 19.9,
    y2: 16.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 8.6,
    y1: 12.1,
    x2: 9.7,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 14.1,
    y1: 25.4,
    x2: 15.2,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 3.9,
    y1: 16.8,
    x2: 6.6,
    y2: 17.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 17.2,
    y1: 22.3,
    x2: 19.9,
    y2: 23.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 15.2,
    y1: 12.1,
    x2: 14.1,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 9.7,
    y1: 25.4,
    x2: 8.6,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    cx: 22.5,
    cy: 9.5,
    r: 4.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 17.5,
    y1: 14.5,
    x2: 19.2,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 25.8,
    y1: 6.2,
    x2: 27.4,
    y2: 4.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 17.5,
    y1: 4.6,
    x2: 19.2,
    y2: 6.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 25.8,
    y1: 12.8,
    x2: 27.4,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 15.5,
    y1: 9.5,
    x2: 17.8,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 27.2,
    y1: 9.5,
    x2: 29.5,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 22.5,
    y1: 2.5,
    x2: 22.5,
    y2: 4.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 22.5,
    y1: 14.2,
    x2: 22.5,
    y2: 16.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.b2dd5f498793539d8d234a5169fcdf86.svg";
export { ForwardRef as ReactComponent };